/* eslint-disable no-shadow */
import useSWR from 'swr';

import { fetchModel } from 'src/store/api';

const defaultConfig = {
  shouldFetch: true,
  revalidateIfStale: false,
  revalidateOnMount: false,
  revalidateOnFocus: false,
};

export default function useModel({ modelId, options = {}, config = {} }) {
  const { shouldFetch, ...swrConfig } = { ...defaultConfig, ...config };

  const url = `/core/v2/thinkalike_model/${modelId}`;
  const requestOptions = { ...options };

  return useSWR(
    shouldFetch ? { key: url, requestOptions } : null,
    ({ requestOptions: o }) => fetchModel(modelId, o),
    swrConfig
  );
}
